import React, { useState } from "react";
import { toast } from "sonner";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { api, formatApiErrorDetail } from "../lib/data";
import { Phone, MapPin, Mail, Clock } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent! Our team will reply within one business day.");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setSending(false); }
  };
  return (
    <div>
      <Navbar />
      <div className="max-w-6xl mx-auto px-6 py-16 grid lg:grid-cols-2 gap-12">
        <div>
          <p className="font-mono text-xs uppercase tracking-widest text-[#00B368] mb-3">Get In Touch</p>
          <h1 className="font-display text-4xl sm:text-5xl tracking-tight text-[#0A1914] mb-4">Contact us</h1>
          <p className="text-gray-600 mb-10 max-w-md">Questions about a course, payouts, or your account? Reach out and a member of our team will help.</p>
          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <Phone className="h-5 w-5 text-[#00B368] mt-1" />
              <div><p className="font-semibold text-[#0A1914]">Phone</p><a href="tel:+12154959156" className="text-sm text-[#00B368] hover:underline" data-testid="contact-phone">215-495-9156</a></div>
            </div>
            <div className="flex items-start gap-4">
              <MapPin className="h-5 w-5 text-[#00B368] mt-1" />
              <div><p className="font-semibold text-[#0A1914]">Office Address</p><p className="text-sm text-gray-600" data-testid="contact-address">Meadows Business Park<br />6340 Security Blvd, Suite 100<br />Woodlawn, MD 21207</p></div>
            </div>
            <div className="flex items-start gap-4">
              <Mail className="h-5 w-5 text-[#00B368] mt-1" />
              <div><p className="font-semibold text-[#0A1914]">Email</p><p className="text-sm text-gray-600">support@electronics-galore.com</p></div>
            </div>
            <div className="flex items-start gap-4">
              <Clock className="h-5 w-5 text-[#00B368] mt-1" />
              <div><p className="font-semibold text-[#0A1914]">Payouts</p><p className="text-sm text-gray-600">Every Friday before 4pm EST</p></div>
            </div>
          </div>
        </div>
        <div className="border border-gray-200 bg-white p-8">
          <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
            <div>
              <label className="text-xs font-mono uppercase tracking-wider text-gray-500">Name</label>
              <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full mt-1 border border-gray-300 rounded-sm px-3 py-2.5 focus:border-[#00B368] focus:ring-1 focus:ring-[#00B368]/20 outline-none" />
            </div>
            <div>
              <label className="text-xs font-mono uppercase tracking-wider text-gray-500">Email</label>
              <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full mt-1 border border-gray-300 rounded-sm px-3 py-2.5 focus:border-[#00B368] focus:ring-1 focus:ring-[#00B368]/20 outline-none" />
            </div>
            <div>
              <label className="text-xs font-mono uppercase tracking-wider text-gray-500">Message</label>
              <textarea required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full mt-1 border border-gray-300 rounded-sm px-3 py-2.5 focus:border-[#00B368] focus:ring-1 focus:ring-[#00B368]/20 outline-none resize-none" />
            </div>
            <button data-testid="contact-submit" disabled={sending} className="w-full bg-[#0A1914] text-white py-3 rounded-sm hover:bg-[#00B368] transition-colors disabled:opacity-50">{sending ? "Sending…" : "Send message"}</button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}
